/* eslint-disable eol-last */
/* eslint-disable no-use-before-define */
/* eslint-disable indent */
export {
    picsSmall,
    picsLarge
}

// 按篇章目录导入
const par1filesSmall = require.context('../assets/dpi72/par1', false, /\.jpg$/)
const par2filesSmall = require.context('../assets/dpi72/par2', false, /\.jpg$/)
const par3filesSmall = require.context('../assets/dpi72/par3', false, /\.jpg$/)
const par4filesSmall = require.context('../assets/dpi72/par4', false, /\.jpg$/)
const par5filesSmall = require.context('../assets/dpi72/par5', false, /\.jpg$/)
const par6filesSmall = require.context('../assets/dpi72/par6', false, /\.jpg$/)

const par1filesLarge = require.context('../assets/dpi200/par1', false, /\.jpg$/)
const par2filesLarge = require.context('../assets/dpi200/par2', false, /\.jpg$/)
const par3filesLarge = require.context('../assets/dpi200/par3', false, /\.jpg$/)
const par4filesLarge = require.context('../assets/dpi200/par4', false, /\.jpg$/)
const par5filesLarge = require.context('../assets/dpi200/par5', false, /\.jpg$/)
const par6filesLarge = require.context('../assets/dpi200/par6', false, /\.jpg$/)

// 路径格式处理
var par1urlsSmall = urlProc('/dpi72/par1', par1filesSmall.keys())
var par2urlsSmall = urlProc('/dpi72/par2', par2filesSmall.keys())
var par3urlsSmall = urlProc('/dpi72/par3', par3filesSmall.keys())
var par4urlsSmall = urlProc('/dpi72/par4', par4filesSmall.keys())
var par5urlsSmall = urlProc('/dpi72/par5', par5filesSmall.keys())
var par6urlsSmall = urlProc('/dpi72/par6', par6filesSmall.keys())

var par1urlsLarge = urlProc('/dpi200/par1', par1filesLarge.keys())
var par2urlsLarge = urlProc('/dpi200/par2', par2filesLarge.keys())
var par3urlsLarge = urlProc('/dpi200/par3', par3filesLarge.keys())
var par4urlsLarge = urlProc('/dpi200/par4', par4filesLarge.keys())
var par5urlsLarge = urlProc('/dpi200/par5', par5filesLarge.keys())
var par6urlsLarge = urlProc('/dpi200/par6', par6filesLarge.keys())

var picsSmall = {
    par1: par1urlsSmall,
    par2: par2urlsSmall,
    par3: par3urlsSmall,
    par4: par4urlsSmall,
    par5: par5urlsSmall,
    par6: par6urlsSmall
}
var picsLarge = {
    par1: par1urlsLarge,
    par2: par2urlsLarge,
    par3: par3urlsLarge,
    par4: par4urlsLarge,
    par5: par5urlsLarge,
    par6: par6urlsLarge
}

// eslint-disable-next-line space-before-function-paren
function urlProc(url, files) {
    var picUrl = []
    for (var i = 0; i < files.length; i++) {
        var filename = files[i].substr(1, files[i].length)
        var fileurl = url + filename
        picUrl.push(fileurl)
    }
    return picUrl
}